module.exports = __webpack_public_path__ + "static/media/invisible-icon.88b1646f.svg";